.coordinates{display:flex;gap:8px}
/*# sourceMappingURL=coordinates-control.component.css.map */
